
<app-chat-side-bar [isExpanded]="sidebarExpanded" (toggleSidebar)="sidebarExpanded = !sidebarExpanded"></app-chat-side-bar>
<div class="content" [ngClass]="{ 'sidebarExpanded': sidebarExpanded }">
  <app-chat-component></app-chat-component>
</div>
